import { render, staticRenderFns } from "./SocialDashboard.vue?vue&type=template&id=41261f30&"
import script from "./SocialDashboard.vue?vue&type=script&lang=js&"
export * from "./SocialDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports